<template>
<div>
    <Breadcrumbs main="Procuremnet" submain="Return" title="Purchase Return" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <!-- <div class="card-header header-mobile"> -->
                        <!-- <router-link to="/procurement/purchase-return/create">
                            <button class="btn btn-primary" type="submit" style="display: flex; align-items: center;">
                                <div style="display: flex; gap: 12px; align-items: center; color: white;">
                                    <i class="fa fa-light fa-plus"></i>
                                    <h7>Add New GRN</h7>
                                </div>
                            </button>
                        </router-link> -->
                    <!-- </div> -->
                   
                    <div class="card-body">
                        <b-row class="d-flex justify-content-center align-items-center">
                            <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                <b-input-group style="width: 340px;">
                                    <b-form-input v-model="filter" placeholder="Type to Search" style="box-shadow: none;"></b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>

                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #563EE0; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="toggleFilterShow()">
                                    <feather type="filter"></feather>
                                    <h7>Filter</h7>
                                </div>
                                <!-- <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #B842B5; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="downloadCSV()">
                                    <h7 class="">Download CSV</h7>
                                </div> -->

                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="statusSelected || start_date || end_date || selectedDepartment ||selectedDesignation || selectedEmployee">
                                    <feather type="x"></feather>
                                    <h7>Clear All</h7>
                                </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="3" label="Per page" class="mb-0 datatable-select w-100">
                                    <b-form-select v-model="perPage" :options="pageOptions" style="width: 100%;"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div class="row mt-2" v-if="filterShow">
                            <div class="col-md-12">
                                <div class="grid-container mt-sm-0">
                                    <div class="grid-item">
                                        <datepicker placeholder="Start Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="start_date"></datepicker>
                                    </div>
                                    <div class="grid-item">
                                        <datepicker placeholder="End Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="end_date"></datepicker>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-select v-model="statusSelected" :options="formattedOptions"></b-form-select>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-select v-model="selectedType" :options="formattedType"></b-form-select>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-select v-model="selectedDepartment" :options="formattedDepartment"></b-form-select>
                                    </div>
                                    <div class="grid-item" v-if="selectedDepartment">
                                        <b-form-select v-model="selectedDesignation" :options="formattedDesignation"></b-form-select>
                                    </div>
                                    <div class="grid-item" v-if="selectedDesignation">
                                        <b-form-select v-model="selectedEmployee" :options="formattedEmployee"></b-form-select>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue" style="margin-top: 22px;">
                                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :per-page="perPage">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>
                                    <template #cell(grn)="data">
                                        <router-link :to="`/procurement/edit-grn/${data.item.grn?.id }`" class="link-style">
                                            {{ data.item.grn?.grn_number }}
                                        </router-link>
                                    </template>
                                    
                                    <template #cell(created_by)="data">
                                        <div style="max-width: 250px;">
                                            {{ data.item.created_by?.username }}
                                        </div>
                                        <div class="d-flex flex-column" v-if="data.item.created_at">
                                            <small class="">Created At: {{ getDate(data.item.created_at) }}</small>
                                        </div>
                                    </template>
                                    <template #cell(confirmed_by)="data">
                                       <div v-if="data.item.confirmed_by">
                                            <div style="max-width: 250px;">
                                                {{ data.item.confirmed_by?.username }}
                                            </div>
                                            <div class="d-flex flex-column" v-if="data.item.confirmed_at">
                                                <small class="">Confirmed At: {{ getDate(data.item.confirmed_at) }}</small>
                                            </div>
                                       </div>
                                       <div v-else>
                                            <b-button variant="outline-info" size="sm" @click="changeStatus(data.item.id, 'confirm')">Confirm</b-button>
                                       </div>
                                    </template>
                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <feather v-if="data.item.status == 'draft'" type="delete" size="20px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteReturn(data.item.id)" title="Delete"></feather>
                                            <router-link :to="`/procurement/purchase-return/${data.item.id}`" >
                                                <feather type="eye" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="View"></feather>
                                            </router-link> 
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                        <div v-else>
                            <div class="loader-box">
                                <div class="loader-10"></div>
                            </div>
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Purchase Return Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this purchase return?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import moment from "moment";
import Datepicker from 'vuejs-datepicker';
import {
    myHost
} from '../../../_helpers/host';
import Multiselect from 'vue-multiselect';

export default {
    components: {
        Datepicker,
        Multiselect
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'return_number',
                    label: 'Return No',
                    sortable: true
                },
                {
                    key: 'grn',
                    label: 'GRN No',
                    sortable: true
                },
                {
                    key: 'reason',
                    label: 'Reason',
                    sortable: true
                },
                {
                    key: 'created_by',
                    label: 'Created By',
                    sortable: false
                },
                {
                    key: 'confirmed_by',
                    label: 'Confirmed By',
                    sortable: false
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            requisition_due: '',
            filter: null,
            filterShow: false,
            start_date: null,
            end_date: null,
            statusSelected: '',
            selectedDepartment: '',
            selectedDesignation: '',
            selectedEmployee: '',
            statuses_list: [{
                    id: 1,
                    name: 'Pending',
                    value: 'PENDING'
                },
                {
                    id: 2,
                    name: 'Approved',
                    value: 'APPROVED'
                },
                {
                    id: 3,
                    name: 'Due',
                    value: 'DUE',
                },
                {
                    id: 4,
                    name: 'Rejected',
                    value: 'REJECTED',
                },
            ],
            temp_id: '',
            assignedMembers: [],
            my_reply: {
                id: '',
                reply: '',
                refer_to: '',
            },
            initialLoad: true,
            delete_value: null,
            selectedStatus: null,
            update_id: null,
            statuses: ['SUBMIT', 'APPROVED'],
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],
            isModifyingDate: false,
            selectedType: '',
        };
    },

    computed: {
        ...mapState({
            items: state => state.purchaseReturn.return,
            count: state => state.purchaseReturn.return_count,
         
            loading: state => state.grn.submitLoading,
            error: state => state.grn.submitError,
            
            department_list: state => state.department.departments,
            designation_list: state => state.department.designation_by_department,
            employee_list: state => state.department.employee_by_designation,
            req_replies: state => state.requisition.req_reply,
            user_list: state => state.employee.employee_list,
            req_type: state => state.requisition.requisition_type,
        }),

        formattedOptions() {
            return [{
                    value: '',
                    text: 'Select Status',
                    disabled: true
                },
                ...this.statuses_list.map(status => ({
                    value: status.value,
                    text: status.name
                }))
            ];
        },

        formattedUserList() {
            return this.user_list.map(user => ({
                ...user,
                full_name: `${user.first_name} ${user.last_name}`
            }));
        },

        formattedEmployee() {
            return [{
                    value: '',
                    text: 'Select Employee',
                    disabled: true
                },
                ...this.employee_list.map(emp => ({
                    value: emp.id,
                    text: emp.full_name
                }))
            ];
        },

        formattedDesignation() {
            return [{
                    value: '',
                    text: 'Select Designation',
                    disabled: true
                },
                ...this.designation_list.map(desg => ({
                    value: desg.id,
                    text: desg.title
                }))
            ];
        },

        formattedDepartment() {
            return [{
                    value: '',
                    text: 'Select Department',
                    disabled: true
                },
                ...this.department_list.map(dept => ({
                    value: dept.id,
                    text: dept.name
                }))
            ];
        },
        formattedType() {
            return [{
                    value: '',
                    text: 'Select Requisition Type',
                    disabled: true
                },
                ...this.req_type.map(type => ({
                    value: type.id,
                    text: type.name
                }))
            ];
        },

    },

    watch: {
        filter(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("purchaseReturn/fetchPurchaseReturn", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    status: this.statusSelected,
                    search_term: this.filter,
                    raised_by: this.selectedEmployee,
                    req_type: this.selectedType
                }).then(() => {
                    this.currentPage = 1
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },

        assignedMembers: {
            handler: function (newVal, oldVal) {
                this.storeAssignedMembers(newVal);
            },
            deep: true
        },

        selectedDepartment(newVal, oldVal) {
            this.$store.dispatch("department/fetchDesignationByDepartment", newVal)
        },

        selectedDesignation(newVal, oldVal) {
            this.$store.dispatch("department/fetchEmployeeByDesignation", newVal)
        },

        statusSelected(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("purchaseReturn/fetchPurchaseReturn", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    status: this.statusSelected,
                    search_term: this.filter,
                    raised_by: this.selectedEmployee,
                    req_type: this.selectedType
                }).then(() => {
                    this.currentPage = 1
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },
        selectedType(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("purchaseReturn/fetchPurchaseReturn", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    status: this.statusSelected,
                    search_term: this.filter,
                    raised_by: this.selectedEmployee,
                    req_type: this.selectedType
                }).then(() => {
                    this.currentPage = 1
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },

        selectedEmployee(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("purchaseReturn/fetchPurchaseReturn", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    status: this.statusSelected,
                    search_term: this.filter,
                    raised_by: this.selectedEmployee,
                    req_type: this.selectedType
                }).then(() => {
                    this.currentPage = 1
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },

        start_date(newVal, oldVal) {
            if (!this.initialLoad) {
                if (!this.isModifyingDate) {
                    this.isModifyingDate = true;
                    if (this.start_date !== null) {
                        this.start_date = moment(String(this.start_date)).format("YYYY-MM-DD");
                        this.$store.dispatch("purchaseReturn/fetchPurchaseReturn", {
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            status: this.statusSelected,
                            search_term: this.filter,
                            raised_by: this.selectedEmployee,
                            req_type: this.selectedType
                        }).then(() => {
                            this.currentPage = 1
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false;
                        });
                    } else {
                        this.$store.dispatch("purchaseReturn/fetchPurchaseReturn", {
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            status: this.statusSelected,
                            search_term: this.filter,
                            raised_by: this.selectedEmployee,
                            req_type: this.selectedType
                        }).then(() => {
                            this.currentPage = 1
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false;
                        });
                    }
                }

            }

        },

        end_date(newVal, oldVal) {
            if (!this.initialLoad) {
                if (!this.isModifyingDate) {
                    this.isModifyingDate = true;
                    if (this.end_date !== null) {
                        this.end_date = moment(String(this.end_date)).format("YYYY-MM-DD");
                        this.$store.dispatch("purchaseReturn/fetchPurchaseReturn", {
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            status: this.statusSelected,
                            search_term: this.filter,
                            raised_by: this.selectedEmployee,
                            req_type: this.selectedType
                        }).then(() => {
                            this.currentPage = 1
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false;
                        });
                    } else {
                        this.$store.dispatch("purchaseReturn/fetchPurchaseReturn", {
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            status: this.statusSelected,
                            search_term: this.filter,
                            raised_by: this.selectedEmployee,
                            req_type: this.selectedType
                        }).then(() => {
                            this.currentPage = 1
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false;
                        });
                    }
                }

            }

        },

        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/procurement/purchase-return',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });
                this.currentPage = newCurrentPage
                this.$store.dispatch("purchaseReturn/fetchPurchaseReturn", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    status: this.statusSelected,
                    search_term: this.filter,
                    raised_by: this.selectedEmployee,
                    req_type: this.selectedType
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/procurement/purchase-return',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage
                    }
                });
                this.perPage = newperPage
                this.$store.dispatch("purchaseReturn/fetchPurchaseReturn", {
                    perPage: newperPage,
                    currentPage: this.currentPage,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    status: this.statusSelected,
                    search_term: this.filter,
                    raised_by: this.selectedEmployee,
                    req_type: this.selectedType
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        }
    },

    mounted() {
        this.$store.dispatch("employee/fetchEmployeeList");
        this.$store.dispatch("department/fetchDepartments");
        this.$store.dispatch("requisition/fetchPurchaseRequisitionType")
        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {

                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });

                this.fetchInitial();
            } else {

                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);

                this.fetchInitial();
            }
        }

    },

    methods: {
        getDate(date) {
            return moment(String(moment(date))).format("YYYY-MM-DD")
        },

        changeStatus(id) {
            this.$store.dispatch("purchaseReturn/confirmPurchaseReturn", {
                id: id,
                perPage: this.$route.query.perPage,
                page: this.$route.query.page,
                start_date: this.start_date,
                end_date: this.end_date,
                status: this.statusSelected,
                search_term: this.filter,
                raised_by: this.selectedEmployee
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        fetchInitial() {
            this.$store.dispatch("purchaseReturn/fetchPurchaseReturn", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                start_date: this.start_date,
                end_date: this.end_date,
                status: this.statusSelected,
                search_term: this.filter,
                raised_by: this.selectedEmployee,
                req_type: this.selectedType
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        clearFilter() {
            this.filterShow = false,
            this.filter = null,
            this.statusSelected = '',
            this.start_date = null,
            this.end_date = null,
            this.selectedDepartment = '',
            this.selectedDesignation = '',
            this.selectedEmployee = ''
        },

        toggleFilterShow() {
            this.filterShow = !this.filterShow
        },

        formattedDate(dateString) {
            return moment(dateString).format('YYYY-MM-DD');
        },

        deleteReturn(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("purchaseReturn/deletePurchaseReturn", {
                delete: this.delete_value,
                perPage: this.$route.query.perPage,
                page: this.$route.query.page,
                start_date: this.start_date,
                end_date: this.end_date,
                status: this.statusSelected,
                search_term: this.filter,
                raised_by: this.selectedEmployee
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        editReturn(item) {
            this.update_id = item.id
            this.$store.dispatch("purchaseReturn/fetchPurchaseReturnById", this.update_id).then(response => {
                if (response.code == 200) {
                    this.$router.push(`/procurement/edit-grn/${this.update_id}`)
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

      
      

        Reply(type) {
            this.my_reply.id = type.id
            this.my_reply.reply = type.name
            this.my_reply.refer_to = type.refering_to
            this.$store.dispatch("requisition/fetchReqReply", this.my_reply.id)
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleReplySubmit()
        },

        handleReplySubmit() {
            if (this.my_reply.reply) {
                this.$store.dispatch("requisition/addReqReply", {
                    req: this.my_reply.id,
                    reply: this.my_reply.reply
                }).then(response => {

                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        // this.my_reply.id = '',
                        this.my_reply.reply = ''

                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })

                // this.$nextTick(() => {
                //     this.$bvModal.hide('modal-scrollable')
                // })
            }
        },

        storeAssignedMembers(assignedMembers) {
            const latestId = assignedMembers[assignedMembers.length - 1].id;

            this.$store.dispatch("requisition/RequisitionAddRefer", {
                id: this.my_reply.id,
                refer_id: latestId,
                page: this.$route.query.page,
                perPage: this.$route.query.perPage,
                start_date: this.start_date,
                end_date: this.end_date,
                status: this.statusSelected,
                raised_by: this.selectedEmployee,
                allReq: true
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.assignedMembers = '';

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-scrollable')
            })
        },

        deletetAllocation(id) {
            this.temp_id = id
        },

        handleAllocationDeleteOk() {

            this.$store.dispatch("requisition/RequisitionDeleteRefer", {
                id: this.my_reply.id,
                refer_id: this.temp_id,
                page: this.$route.query.page,
                perPage: this.$route.query.perPage,
                start_date: this.start_date,
                end_date: this.end_date,
                status: this.statusSelected,
                raised_by: this.selectedEmployee,
                allReq: true
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.assignedMembers = '';

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-scrollable')
            })
        },

        downloadCSV() {
            this.$store.dispatch("requisition/fetchPurchaseRequisition", {
                    start_date: this.start_date,
                    end_date: this.end_date,
                    status: this.statusSelected,
                    search_term: this.filter,
                    raised_by: this.selectedEmployee,
                    req_type: this.selectedType
                })
                .then(response => {

                    const blob = new Blob([response.data], {
                        type: 'text/csv'
                    });

                    const url = window.URL.createObjectURL(blob);

                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'requisition.csv');
                    document.body.appendChild(link);
                    link.click();

                    link.remove();
                    URL.revokeObjectURL(url);

                    // Swal.fire({
                    //     title: "Success!",
                    //     text: "CSV downloaded successfully",
                    //     icon: "success"
                    // });
                })
                .catch(() => {
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to download CSV",
                        icon: "error"
                    });
                });

        }

    }
};
</script>

<style scoped>
.header-mobile {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media screen and (max-width: 460px) {
    .header-mobile {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: start;
    }
}

.img-30 {
    width: 30px !important;
    height: 30px !important;
}

.badge-style {
    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-items: center;
    background-color: #2c323f;
    padding: 0.375rem 1.75rem;
    color: white;
}

.badge-style:hover {
    background-color: #ff595d;
}

.chatbox {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 0px 10px;
}

.chat {
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
    word-break: break-all;
}

.avatar img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    border: solid 2px white;
}

.message {
    flex-grow: 1;
}

.msg {
    background: #fff0f0;
    width: 100%;
    /* Ensures message takes full width */
    padding: 10px;
    border-radius: 10px;
    position: relative;
    font-size: 13px;
    word-break: break-all;
}

.task-board-comments {
    height: 450px;
    overflow-y: auto;
}

/* height */
::-webkit-scrollbar {
    height: 6px;
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.mini-box {
    padding: 5px 10px;
    border-radius: 8px;
    transition: 0.3s ease;
}

.mini-box:hover {
    transform: translateY(-3px);
}

.advance-box .mini-label {
    font-size: 14px;
    color: #c4a50f;
    font-weight: 600;
}

.settled-box .mini-label {
    font-size: 14px;
    color: #388616b9;
    font-weight: 600;
}

.mini-box.advance-box {
    background: #f8d62b2c;
}

.mini-box.settled-box {
    background: #66c23e36;
}
</style>
